import _get from 'lodash/get'

export const getScrollToGuestTicketFormElement = errors => {
  let scrollTo = ''
  const ticketTypeID = _get(errors, 'ticketTypeID')
  const tableTypeID = _get(errors, 'tableTypeID')
  const email = _get(errors, 'email')
  const confirmEmail = _get(errors, 'confirmEmail')
  const quantity = _get(errors, 'quantity')

  const ticketHolders = _get(errors, 'ticketHolders')

  if (ticketTypeID || tableTypeID || email || confirmEmail || quantity) {
    scrollTo = 'scroll-to-top'
  } else if (ticketHolders?.length) {
    const index = ticketHolders.findIndex(Boolean)
    scrollTo = `scroll-to-ticket-holder-${index}`
  }

  return scrollTo
}
